/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BaselineEntity } from './BaselineEntity';
import {
    BaselineEntityFromJSON,
    BaselineEntityFromJSONTyped,
    BaselineEntityToJSON,
    BaselineEntityToJSONTyped,
} from './BaselineEntity';

/**
 * 
 * @export
 * @interface BaselineAssessmentRun
 */
export interface BaselineAssessmentRun {
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof BaselineAssessmentRun
     */
    discoveredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineAssessmentRun
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineAssessmentRun
     */
    decommissionedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    status?: BaselineAssessmentRunStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BaselineAssessmentRun
     */
    extendedAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof BaselineAssessmentRun
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineAssessmentRun
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    updatedBy?: string;
    /**
     * 
     * @type {BaselineEntity}
     * @memberof BaselineAssessmentRun
     */
    baseline?: BaselineEntity;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    assessmentType?: string;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    scannerId?: string;
    /**
     * 
     * @type {Date}
     * @memberof BaselineAssessmentRun
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BaselineAssessmentRun
     */
    completedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    assessmentStatus?: BaselineAssessmentRunAssessmentStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaselineAssessmentRun
     */
    assetIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    totalAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    assessedAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    failedAssets?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    totalConfigItems?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    compliantItems?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    nonCompliantItems?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    errorItems?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    newWeaknessesCreated?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    existingWeaknessesUpdated?: number;
    /**
     * 
     * @type {number}
     * @memberof BaselineAssessmentRun
     */
    weaknessesResolved?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof BaselineAssessmentRun
     */
    scannerMetadata?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof BaselineAssessmentRun
     */
    oscalAssessmentResultRef?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaselineAssessmentRun
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaselineAssessmentRun
     */
    decommissioned?: boolean;
}


/**
 * @export
 */
export const BaselineAssessmentRunStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type BaselineAssessmentRunStatusEnum = typeof BaselineAssessmentRunStatusEnum[keyof typeof BaselineAssessmentRunStatusEnum];

/**
 * @export
 */
export const BaselineAssessmentRunAssessmentStatusEnum = {
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;
export type BaselineAssessmentRunAssessmentStatusEnum = typeof BaselineAssessmentRunAssessmentStatusEnum[keyof typeof BaselineAssessmentRunAssessmentStatusEnum];


/**
 * Check if a given object implements the BaselineAssessmentRun interface.
 */
export function instanceOfBaselineAssessmentRun(value: object): value is BaselineAssessmentRun {
    return true;
}

export function BaselineAssessmentRunFromJSON(json: any): BaselineAssessmentRun {
    return BaselineAssessmentRunFromJSONTyped(json, false);
}

export function BaselineAssessmentRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaselineAssessmentRun {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : (new Date(json['discoveredAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'extendedAttributes': json['extendedAttributes'] == null ? undefined : json['extendedAttributes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'baseline': json['baseline'] == null ? undefined : BaselineEntityFromJSON(json['baseline']),
        'assessmentType': json['assessmentType'] == null ? undefined : json['assessmentType'],
        'scannerId': json['scannerId'] == null ? undefined : json['scannerId'],
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'assessmentStatus': json['assessmentStatus'] == null ? undefined : json['assessmentStatus'],
        'assetIds': json['assetIds'] == null ? undefined : json['assetIds'],
        'totalAssets': json['totalAssets'] == null ? undefined : json['totalAssets'],
        'assessedAssets': json['assessedAssets'] == null ? undefined : json['assessedAssets'],
        'failedAssets': json['failedAssets'] == null ? undefined : json['failedAssets'],
        'totalConfigItems': json['totalConfigItems'] == null ? undefined : json['totalConfigItems'],
        'compliantItems': json['compliantItems'] == null ? undefined : json['compliantItems'],
        'nonCompliantItems': json['nonCompliantItems'] == null ? undefined : json['nonCompliantItems'],
        'errorItems': json['errorItems'] == null ? undefined : json['errorItems'],
        'newWeaknessesCreated': json['newWeaknessesCreated'] == null ? undefined : json['newWeaknessesCreated'],
        'existingWeaknessesUpdated': json['existingWeaknessesUpdated'] == null ? undefined : json['existingWeaknessesUpdated'],
        'weaknessesResolved': json['weaknessesResolved'] == null ? undefined : json['weaknessesResolved'],
        'scannerMetadata': json['scannerMetadata'] == null ? undefined : json['scannerMetadata'],
        'oscalAssessmentResultRef': json['oscalAssessmentResultRef'] == null ? undefined : json['oscalAssessmentResultRef'],
        'active': json['active'] == null ? undefined : json['active'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
    };
}

export function BaselineAssessmentRunToJSON(json: any): BaselineAssessmentRun {
    return BaselineAssessmentRunToJSONTyped(json, false);
}

export function BaselineAssessmentRunToJSONTyped(value?: BaselineAssessmentRun | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'discoveredAt': value['discoveredAt'] == null ? undefined : ((value['discoveredAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'version': value['version'],
        'extendedAttributes': value['extendedAttributes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'baseline': BaselineEntityToJSON(value['baseline']),
        'assessmentType': value['assessmentType'],
        'scannerId': value['scannerId'],
        'startedAt': value['startedAt'] == null ? undefined : ((value['startedAt']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'assessmentStatus': value['assessmentStatus'],
        'assetIds': value['assetIds'],
        'totalAssets': value['totalAssets'],
        'assessedAssets': value['assessedAssets'],
        'failedAssets': value['failedAssets'],
        'totalConfigItems': value['totalConfigItems'],
        'compliantItems': value['compliantItems'],
        'nonCompliantItems': value['nonCompliantItems'],
        'errorItems': value['errorItems'],
        'newWeaknessesCreated': value['newWeaknessesCreated'],
        'existingWeaknessesUpdated': value['existingWeaknessesUpdated'],
        'weaknessesResolved': value['weaknessesResolved'],
        'scannerMetadata': value['scannerMetadata'],
        'oscalAssessmentResultRef': value['oscalAssessmentResultRef'],
        'active': value['active'],
        'decommissioned': value['decommissioned'],
    };
}

